import { useCallback, useEffect, useMemo, useState } from 'react';
import { readLinkedInCampaigns } from '../../conversion-goals-repository';

const CompatibleGoalTypes = ['EventGoal', 'DestinationGoal'];

export const useShowNetworkCards = ({
  cid, aid, permissions,
}) => {
  const isLinkedInEnabled = useMemo(() =>
    permissions && permissions.dynamic && permissions.dynamic.LinkedInCampaigns, [permissions]);

  const [hasCampaigns, setHasCampaigns] = useState();

  useEffect(() => {
    readLinkedInCampaigns(cid, aid)
      .then(res => setHasCampaigns(res.value.length > 0))
      .catch(() => setHasCampaigns(false));
  }, [aid, cid]);

  const showNetworkCards = useCallback(selectedGoalType => (
    (isLinkedInEnabled && hasCampaigns && CompatibleGoalTypes.includes(selectedGoalType))
  ), [isLinkedInEnabled, hasCampaigns]);

  return showNetworkCards;
};
